import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { Establishment } from "@/types/http/Establishment"
import type { EstablishmentDistribution } from "@/types/http/EstablishmentDistribution"

export const useEstablishmentStore = defineStore('ssr_establishment', () => {
  const establishment = ref<Establishment | null>(null)
  const setEstablishment = (value: Establishment) => establishment.value = value

  const establishmentDistribution = ref<EstablishmentDistribution | null>(null)
  const setEstablishmentDistribution = (value: EstablishmentDistribution) => establishmentDistribution.value = value

  const discounts = ref<any[] | null>(null)
  const setDiscounts = (value: any[]) => discounts.value = value

  const faqs = ref<any[] | null>(null)
  const setFaqs = (value: any[]) => faqs.value = value

  const clear = () => {
    establishment.value = null
    establishmentDistribution.value = null
    discounts.value = null
    faqs.value = null
  }

  return {
    establishment,
    setEstablishment,

    establishmentDistribution,
    setEstablishmentDistribution,

    discounts,
    setDiscounts,

    faqs,
    setFaqs,

    clear,
  }
})